import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { SpinnerService } from '~shared/components/buttons/spinner/spinner.service';
@Component({
  selector: 'app-local-modal',
  templateUrl: 'local-modal.component.html'
})

export class LocalModalComponent implements OnInit {
  public isOpen: boolean = false;

  @Output() public submitClicked: EventEmitter<string> = new EventEmitter<string>();

  @Input() public spinnerName: string = 'localModalSubmit';
  @Input() public title: string;
  @Input() public showSubmitButton: boolean = true;
  @Input() public showCancelButton: boolean = true;
  @Input() public large: boolean = false;
  @Input() public big: boolean = false;
  @Input() public loading: boolean = false;
  @Input() public submitButton: string = '';
  @Input() public backButton: string = '';
  @Input() public submitDisabled: boolean;

  constructor(private buttonTranslations: ButtonsTranslations, private spinnerService: SpinnerService) {
    if (!this.submitButton) {
      this.submitButton = this.buttonTranslations.i18nSubmit;
    }
    if (!this.backButton) {
      this.backButton = this.buttonTranslations.i18nBack;
    }
  }

  ngOnInit(): void { }

  get showSpinner(): boolean {
    return this.spinnerService.isShowing(this.spinnerName);
  }

  public setModalStatus(status: boolean): void {
    this.isOpen = status;
  }

  public submitButtonClicked(): void {
    this.submitClicked.emit('click');
  }

  public cancelButtonClicked(): void {
    this.setModalStatus(false);
  }

  public setSpinner(status: boolean) {
    if (status) {
      this.spinnerService.show(this.spinnerName);
    } else {
      this.spinnerService.hide(this.spinnerName);
    }
  }
}
